<template>
  <div class="content">
    <div class="md-layout justify-content-center">
      <div class="md-layout-item md-medium-size-100 md-size-50">
        <edit-profile-form data-background-color="green"> </edit-profile-form>
      </div>
      <!-- <div class="md-layout-item md-medium-size-100 md-size-33">
        <user-card> </user-card>
      </div> -->
    </div>
  </div>
</template>

<script>
import {
  EditProfileForm
  //UserCard
} from "@/pages";

export default {
  components: {
    EditProfileForm
    //UserCard
  }
};
</script>
<style>
.justify-content-center {
  justify-content: center;
}
</style>
